<template>
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{title}}
          </h3>
          <span v-if="search.length >= 1" class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{tablePageData.length}} resultados
          </span>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 text-right">
          <a href="#!" class="btn btn-primary" @click="createCustomerParentModal = true">Nuevo cliente</a>
        </div>
      </div>
    </div>
    <base-input class="px-4" placeholder="Buscar" v-model="search"> </base-input>
    <div class="table-responsive" v-if="search.length >= 1">
      <base-table class="table align-items-center table-flush"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                  tbody-classes="list"
                  :data="tablePageData">
        <template slot="columns">
          <th>ID Cliente</th>
          <th>R. Social</th>
          <th>Creado el</th>
          <th></th>
        </template>

        <template slot-scope="{row}">
          <th @click="selectRow(row)">
           {{row.clientId}}
          </th>
          <th scope="row" @click="selectRow(row)">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.razonSocial}}</span>
              </div>
            </div>
          </th>
          <td class="align-items-center">
            {{getReadableDate(row.createdOn)}}
          </td>
          <td class="text-right">
            <i class="ni ni-check-bold" @click="selectRow(row)"></i>
          </td>
        </template>
      </base-table>
    </div>
    <modal v-if="createCustomerParentModal" :show.sync="createCustomerParentModal"
               body-classes="p-0"
               modal-classes="modal-dialog-centered modal-sm">
            <card type="secondary" shadow
                  header-classes="bg-white pb-5"
                  body-classes="px-lg-5 py-lg-5"
                  class="border-0">
                  <template>
                    <form role="form">
                        <base-input alternative
                                    label="Razón social"
                                    class="mb-3"
                                    v-model="newCustomer.razonSocial"
                                    placeholder="Razón social">
                        </base-input>
                        <base-input alternative="" label="Notas">
                            <textarea rows="4" v-model="newCustomer.notas" class="form-control form-control-alternative" placeholder="Notas y comentarios acerca del cliente"></textarea>
                        </base-input>
                        <div class="text-center">
                            <button type="button" class="btn btn-warning"
                                    @click="createCustomerParentModal = false"
                                    aria-label="Cancelar">
                                    Cancelar
                            </button>
                            <button v-if="canSave" 
                                    type="button" 
                                    class="btn btn-default"
                                    @click="saveNewCustomerParent"
                                    aria-label="Guardar">
                                    Guardar
                            </button>
                        </div>
                    </form>
                </template>
            </card>
        </modal>
  </div>
</template>
<script>
import moment from "moment";
export default {
    name: 'clients-table-picker',
    props: {
      type: {
        type: String
      },
      title: String,
      tableData: Array
    },
    computed: {
      tablePageData: function () {
        let search = this.search.toUpperCase();
        return this.tableData.filter((item) => {
          let containsClientId = item.clientId.toUpperCase().includes(search);
          let containsRazonSocial = item.razonSocial.toUpperCase().includes(search);
          let containsCreatedBy = item.createdBy.toUpperCase().includes(search);
          return containsClientId || containsRazonSocial || containsCreatedBy;
        })
      },
      canSave(){
        return this.newCustomer.razonSocial && !this.isEmptyOrSpaces(this.newCustomer.razonSocial);
      }
    },
    methods:{
      isEmptyOrSpaces(str){
        return str === null || str.match(/^\s*$/) !== null;
      },
      getReadableDate(timestamp){
        moment.locale('es');
        let time = moment(timestamp, 'x')
        return time.format('ll');
      },
      selectRow(row){
        this.$emit('client-selected', row);
      },
      saveNewCustomerParent(){
        const token = localStorage.getItem('id_token');
        fetch(`${process.env.VUE_APP_VREMEC_API}/api/clients`, {
            method: 'POST', 
            body: JSON.stringify(this.newCustomer),
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => response.json()).catch(err => console.log(err))
        .then((data) => {
            this.createCustomerParentModal = false;
            this.$emit('next-step', data.Data);
        })
      }
    },
    data() {
      return {
        search: '',
        createCustomerParentModal: false,
        newCustomer: {
          notas: '',
          razonSocial: ''
        }
      }
    }
  }
</script>
<style>
</style>